<template>
  <div>
    <div class="animated fadeIn">
      <CRow>
        <CCol lg="12">
          <div class="text-center p-5 row" v-if="isLoading">
            <semipolar-spinner
              :animation-duration="2000"
              :size="80"
              color="#63c2de"
              class="offset-6"
            >Entrar</semipolar-spinner>
          </div>
          <TableQuiz :table-data="items" :fields="fields" caption="Surveys" v-else></TableQuiz>
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TableQuiz from "./TableQuiz.vue";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

export default {
  name: "tables",
  components: { SemipolarSpinner, TableQuiz },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "domain_id", label: "Dominio web", sortable: true },
        { key: "slug2", label: "Slug", sortable: true },
        { key: "link", label: "Link", sortable: true },
        { key: "acciones", label: "Acciones" },
        // { key: "stat_ids", label: "stat_ids" }
      ],
      isLoading: false
    };
  },
  mounted() {
    // this.getQuizes();
  },
  methods: {
    getQuizes() {
      // var quizes = store.getters.getQuizes;
      // if (quizes.length == 0) {
        var partner_ids=[];
        var quiz_ids = [];
        var create_date=[];
        var payload =  {
            partner_ids,
            quiz_ids,
            create_date
          }
        this.isLoading = true;
        store.dispatch("getQuizes", payload).then(() => {
          var quizes = store.getters.getQuizes;
          // console.log("quizes :::::::", quizes.domain_id);
          shuffleArray([quizes]);
          this.isLoading = false;
          if(quizes.length > 0){
              this.items = quizes;
              this.itemsArray = quizes;
          }
          else{
              this.items = [];
              this.itemsArray = []; 
          }
          // console.log("items quiz", this.items);
        });
    //   } else {
    //     shuffleArray([quizes]);
    //     this.items = quizes;
    //     this.itemsArray = quizes;
    //   }
    }
  }
};
</script>
<style>
.headstyle {
  float: right;
}

</style>